<template>
  <div>
    <section class="material-half-bg">
      <div class="cover"></div>
    </section>
    <section class="login-content p-sm-5 m-0">
      <div class="logo container mx-auto text-center mt-5">
        <h1 class="display-6"><i class="fas fa-tools"></i> แจ้งบริการไอที</h1>
        <h5 class="">
          บริการที่ผู้ใช้งานสามารถรายงานความผิดปกติของระบบโปรแกรมหรืออุปกรณ์ทั้งหมดที่เกี่ยวข้องกับไอที
          ผ่านช่องทางนี้.
        </h5>
        <router-link to="Dashboard" class="text-center text-white"
          >- สำหรับผู้ดูแลระบบ -</router-link
        >
      </div>
      <div class="card w-100 my-4">
        <div class="card-body">
          <div class="row">
            <div class="col-md p-0 text-center">
              <a
                data-toggle="modal"
                @click="onModal(2)"
                role="button"
                class="btn btn-link"
                style="font-size: 22px"
              >
                <i class="fas fa-desktop" style="font-size: 38px"></i>
                <p class="m-0">บริการ</p>
                <p class="m-0">คอมพิวเตอร์</p>
              </a>
            </div>
            <div class="col-md p-0 text-center">
              <a
                data-toggle="modal"
                @click="onModal(3)"
                role="button"
                class="btn btn-link"
                style="font-size: 22px"
              >
                <i class="fas fa-print" style="font-size: 38px"></i>
                <p class="m-0">บริการ</p>
                <p class="m-0">เครื่องพิมพ์</p>
              </a>
            </div>
            <div class="col-md p-0 text-center">
              <a
                data-toggle="modal"
                @click="onModal(4)"
                role="button"
                class="btn btn-link"
                style="font-size: 22px"
              >
                <i class="fab fa-internet-explorer" style="font-size: 38px"></i>
                <p class="m-0">บริการ</p>
                <p class="m-0">Internet Network</p>
              </a>
            </div>
            <div class="col-md p-0 text-center">
              <a
                data-toggle="modal"
                @click="onModal(6)"
                role="button"
                class="btn btn-link"
                style="font-size: 22px"
              >
                <i class="fas fa-database" style="font-size: 38px"></i>
                <p class="m-0">บริการ</p>
                <p class="m-0">HOSxP</p>
              </a>
            </div>
            <div class="col-md p-0 text-center">
              <a
                data-toggle="modal"
                @click="onModal(1)"
                role="button"
                class="btn btn-link"
                style="font-size: 22px"
              >
                <i class="far fa-window-restore" style="font-size: 38px"></i>
                <p class="m-0">บริการ</p>
                <p class="m-0">โปรแกรมอื่นๆ</p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row w-100">
        <div class="col-md-12 p-0">
          <div class="tile">
            <div class="tile-body">
              <div class="table-responsive" v-if="repairs.length">
                <table class="table table-bordered h5">
                  <thead class="bg-light text-center">
                    <tr>
                      <th>วันที่ เวลา</th>
                      <th>หน่วยงาน</th>
                      <th>รายละเอียด</th>
                      <th>สถานะ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in repairs" :key="index">
                      <td>
                        <span class="text-muted">วันที่ : </span>
                        <span> {{ item.created_at | formatDate }}</span>
                        <br />

                        <span class="text-muted">เวลา : </span>
                        <span> {{ item.created_at | formatTime }}</span>
                      </td>
                      <td>
                        <span class="text-muted">หน่วยงาน : </span>
                        <span> {{ item.department.department_name }}</span>
                        <br />

                        <span class="text-muted">ผู้แจ้ง : </span>
                        <span> {{ item.end_user }}</span>
                      </td>
                      <td>
                        <span class="text-muted">ประเภท : </span>
                        <span>{{ item.type.type_name }}</span>
                        <span class="text-muted"> หมายเหตุ : </span>
                        <span v-if="item.comment">
                          <span class="text-danger"
                            >** {{ item.comment }} **</span
                          >
                        </span>
                        <span v-else>-</span>
                        <br />
                        <span class="text-muted">รายละเอียด : </span>
                        <span>{{ item.description | trimDetails }}</span>
                      </td>
                      <td>
                        <span class="text-muted">สถานะ : </span>
                        <span class="blink_me text-danger">
                          {{ item.status.status_name }}
                        </span>
                        <br />
                        <span class="text-muted">ผู้รับผิดชอบ : </span>
                        <span v-if="item.user">{{ item.user.name }}</span>
                        <span v-else>-</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="text-center">/* ไม่มีข้อมูลบริการ */</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="modal fade" ref="exampleModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">ฟอร์มแจ้งบริการไอที</h5>
            <button
              @click="modal.hide()"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <form
              @submit.prevent="handleSubmit"
              ref="form"
              class="needs-validation form-row"
              novalidate
            >
              <div class="form-group col-md-12">
                <label for="">หน่วยงาน</label>
                <v-select
                  v-model="data.department_id"
                  :options="departments"
                  label="department_name"
                  :reduce="(item) => item.id"
                  placeholder="เลือกหน่วยงาน"
                  selectOnTab
                />
                <div class="invalid-feedback">*ข้อมูลจำเป็น</div>
              </div>
              <div class="form-group col-md-12">
                <label for="">ชื่อผู้ใช้งาน</label>
                <v-select
                  v-model="data.end_user"
                  :options="opduser"
                  label="name"
                  :reduce="(item) => item.name"
                  placeholder="เลือกชื่อผู้ใช้งาน"
                  selectOnTab
                  :dropdown-should-open="dropdownShouldOpen"
                />

                <div class="invalid-feedback">*ข้อมูลจำเป็น</div>
              </div>
              <div class="form-group col-md-8">
                <label for="">เบอร์โทรศัพท์ติดต่อ</label>
                <input
                  v-model="data.mobile"
                  v-mask="'###-###-####'"
                  type="text"
                  class="form-control"
                  placeholder="เบอร์โทรศัพท์ติดต่อ"
                />
              </div>
              <div class="form-group col-md-4">
                <label for="">เบอร์ภายใน</label>
                <input
                  v-model="data.tel"
                  v-mask="'####'"
                  type="text"
                  class="form-control"
                  placeholder="เบอร์ภายใน"
                  required
                />
                <div class="invalid-feedback">*ข้อมูลจำเป็น</div>
              </div>
              <div class="form-group col-md-12">
                <label for="">รายละเอียด</label>
                <textarea
                  v-model="data.description"
                  class="form-control"
                  placeholder="รายละเอียด"
                  rows="3"
                  required
                ></textarea>
                <div class="invalid-feedback">*ข้อมูลจำเป็น</div>
              </div>
              <div class="form-group col-md-12">
                <label for="">IP Address (ถ้ามี)</label>
                <vue-mask
                  class="form-control"
                  v-model="data.ip_address"
                  mask="099.099.099.099"
                  :raw="false"
                  :options="options"
                >
                </vue-mask>
                <small id="helpId" class="form-text text-muted"
                  >สามารถเข้าดูได้ที่นี้
                  <a href="https://moph.cc/Fqid7m1SE" target="_blank">Click!</a>
                  กดเพื่อดู ip address หากท่านไม่ทราบ
                </small>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              v-if="!is_edit"
              @click="handleSubmit"
              type="button"
              class="btn btn-primary"
            >
              <i class="fas fa-save"></i>
              บันทึก
            </button>
            <button
              v-else
              @click="update"
              type="button"
              class="btn btn-warning"
            >
              <i class="fas fa-edit"></i>
              แก้ไข
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              @click="modal.hide()"
            >
              <i class="fas fa-times"></i>
              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import axios from "axios";
import _ from "lodash";
import { debounce } from "lodash";

import { VueRecaptcha } from "vue-recaptcha";
import vueMask from "vue-jquery-mask";

import RepairsService from "../services/repairs.service";
import TypesService from "../services/types.service";
import DepartmentsService from "../services/departments.service";
import httpCommon from "../services/http-common";

export default {
  components: {
    VueRecaptcha,
    vueMask,
  },
  data() {
    return {
      formSubmitted: false,
      value: "",
      modal: null,
      is_edit: false,
      name: this.$route.name,
      types: [],
      repairs: [],
      opduser: [],
      departments: [],
      data: {
        department_id: null,
        type_id: null,
        status_id: 1,
        end_user: "",
        ip_address: "",
        hostname: "",
        os: "",
        browser: "",
        device: "",
      },
      options: {
        placeholder: "192.168.xxx.xxx",
      },
    };
  },
  computed: {
    dataRepairs() {
      return _.filter(this.repairs.data, (o) => o.status_id != 3);
    },
  },
  methods: {
    async getClientInfo() {
      try {
        const res = await axios.get("http://192.168.20.8/client-info.php");

        this.data.ip_address = res.data.ip_address;
        this.data.hostname = res.data.hostname;
        this.data.os = res.data.os;
        this.data.browser = res.data.browser;
        this.data.device = res.data.device;
      } catch (err) {
        console.error("Error getting client info:", err);
      }
    },
    dropdownShouldOpen(VueSelect) {
      return VueSelect.search.length !== 0 && VueSelect.open;
    },
    clear() {
      this.data = {
        department_id: null,
        type_id: null,
        status_id: 1,
        end_user: "",
        ip_address: "",
        hostname: "",
        os: "",
        browser: "",
        device: "",
      };

      this.is_edit = false;
    },
    checkFormValidity() {
      return this.$refs.form.checkValidity();
    },
    async handleSubmit() {
      this.formSubmitted = true;

      if (!this.checkFormValidity()) {
        this.$refs.form.classList.add("was-validated");
        this.showValidate();
        return;
      }

      await this.insert();
      await this.get_repair_process();
      await this.showSuccess();
      await this.modal.hide();
      await this.$refs.form.classList.remove("was-validated");
    },
    debouncedHandleSubmit: debounce(function () {
      this.handleSubmit();
    }, 300),

    async insert() {
      try {
        const res = await RepairsService.create(this.data);

        this.lineNotify(res.data);
        this.sendTelegramNotification(res.data);

        this.clear();

        // broadcast socket
        this.$socket.emit("repair-update", res.data);
      } catch (err) {
        console.error("Error during insert:", err);
      }
    },
    lineNotify(req) {
      return httpCommon.post(`alert`, req);
    },
    sendTelegramNotification(req) {
      return httpCommon.post(`send-telegram-notification`, req);
    },

    getTypes() {
      TypesService.getAll()
        .then((res) => {
          this.types = res.data;
        })
        .catch((err) => {
          console.error("Error loading types:", err);
        });
    },
    getDepartments() {
      DepartmentsService.getAll()
        .then((res) => {
          this.departments = res.data;
        })
        .catch((err) => {
          console.error("Error loading departments:", err);
        });
    },
    getRepairs() {
      RepairsService.getAll()
        .then((res) => {
          // this.repairs = res.data;
        })
        .catch((err) => {
          console.error("Error loading repairs:", err);
        });
    },
    onModal(id) {
      this.data.type_id = id;
      this.modal.show();
    },
    async getOpduser() {
      try {
        const res = await httpCommon.get("opduser");
        this.opduser = res.data;
      } catch (err) {
        console.error("Error loading officers from httpCommon:", err);
      }
    },
    // async getOpduser() {
    //   try {
    //     const res = await axios.get(
    //       "https://api-hos.wanorn.com/backend/api/officer"
    //     );
    //     this.opduser = res.data;
    //   } catch (err) {
    //     console.error("Error loading officers:", err);
    //   }
    // },
    socket_(val) {
      // this.$socket.emit("repair-update", val);
    },
    async get_repair_process() {
      const res = await httpCommon.get("repair_process");
      this.repairs = res.data.data;
    },
  },
  mounted() {
    this.modal = new Modal(this.$refs.exampleModal);

    this.$socket.on("repair-update", () => {
      console.log("socket repair-update received");

      this.get_repair_process();
    });
  },
  beforeDestroy() {
    this.$socket.off("repair-update");
  },
  created() {
    this.getClientInfo();
    this.get_repair_process();
    this.getDepartments();
    this.getOpduser();
    // Optional: setup input mask if needed
    // const ipv4_address = $("#ipv4");
    // ipv4_address.inputmask({
    //   alias: "ip",
    //   greedy: false,
    // });

    // Optional: enable socket broadcast on component load
    // this.$socket.emit("repair-update", "Hello from Vue.");
  },
};
</script>


<style>
.alert {
  background-color: red;
  animation: blinker 3s linear infinite;
}

p {
  margin: 0%;
}

.vs__dropdown-toggle {
  height: calc(1.5em + 0.75rem + 4px);
  border: 2px solid #ced4da;
}

.vs__invaild {
  border-color: #dc3545;
}

.vs__search {
  padding: 0 10px;
}

.blink_me {
  animation: blinker 1.8s linear infinite;
}

@keyframes blinker {
  25% {
    opacity: 0;
  }
}
</style>